import { createStyles, makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      marginTop: theme.spacing(3),
    },
  }),
);
